import React from 'react';
import { KitchenLogo } from '../assets/icons/kitchenLogo';
import krLogo from '../assets/images/KR orange.png';

const Landing = ({ setSearchPage }) => {
  const handleClick = () => {
    setSearchPage(true);
    console.log('clicked');
  };
  return (
    <div className="landing">
      <div className="overlay"></div>
      <div className="content">
        <div className="h1">
          <h1>
            <KitchenLogo fill="white" width="70" height="80" />
            let's <span>COOK</span>
          </h1>
        </div>
        <div className="btn">
          <button className="btn-start" onClick={handleClick}>
            Start Cooking
          </button>
        </div>
        <div className="landing-message">
          <div className="message">Check what's in your fridge</div>
          <div className="message">Search what can you cook</div>
          <div className="message">Bon Appetit</div>
        </div>
      </div>
      <div className="footer">
        <span>Made by</span>
        <a href="https://www.khalidragi.com/">
          <img src={krLogo} alt="khalid Ragi logo" />
        </a>
      </div>
    </div>
  );
};

export default Landing;
